"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("@material-ui/core/styles");
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _Button = _interopRequireDefault(require("../Button"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: _defineProperty({
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      margin: 'auto',
      textAlign: 'center',
      color: theme.palette.darkGrey.main,
      width: 510
    }, theme.breakpoints.down('sm'), {
      width: 345
    }),
    image: _defineProperty({
      maxWidth: 440,
      maxHeight: 350,
      marginBottom: theme.spacing(3)
    }, theme.breakpoints.down('sm'), {
      maxWidth: 250,
      maxHeight: 230
    }),
    title: _defineProperty({
      fontWeight: 600,
      marginBottom: theme.spacing(2)
    }, theme.breakpoints.down('sm'), {
      fontSize: 20
    }),
    buttons: _defineProperty({
      marginTop: theme.spacing(4)
    }, theme.breakpoints.down('sm'), {
      display: 'flex',
      flexDirection: 'column-reverse',
      width: '100%'
    }),
    button: _defineProperty({
      '&:nth-child(2)': {
        marginLeft: theme.spacing(2)
      }
    }, theme.breakpoints.down('sm'), {
      '&:nth-child(2)': {
        marginLeft: 0,
        margin: theme.spacing(9, 0, 2)
      }
    })
  };
});
var FeedbackScreen = function FeedbackScreen(_ref) {
  var image = _ref.image,
    alt = _ref.alt,
    title = _ref.title,
    description = _ref.description,
    secondaryButton = _ref.secondaryButton,
    primaryButton = _ref.primaryButton,
    className = _ref.className;
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx["default"])(classes.root, className)
  }, /*#__PURE__*/_react["default"].createElement("img", {
    className: classes.image,
    src: image,
    alt: alt
  }), title && /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "h5",
    gutterBottom: true,
    className: classes.title
  }, title), /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "body2",
    className: classes.description,
    component: "div"
  }, description), (!!secondaryButton || !!primaryButton) && /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.buttons
  }, secondaryButton && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    onClick: secondaryButton.onClick,
    className: classes.button,
    variant: "secondary",
    icon: secondaryButton.icon
  }, secondaryButton.label), primaryButton && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    onClick: primaryButton.onClick,
    className: classes.button,
    variant: "primary",
    icon: primaryButton.icon
  }, primaryButton.label)));
};
FeedbackScreen.propTypes = {
  image: _propTypes["default"].string.isRequired,
  alt: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  description: _propTypes["default"].node.isRequired,
  primaryButton: _propTypes["default"].shape({
    icon: _propTypes["default"].elementType,
    label: _propTypes["default"].string.isRequired,
    onClick: _propTypes["default"].func.isRequired
  }),
  secondaryButton: _propTypes["default"].shape({
    icon: _propTypes["default"].elementType,
    label: _propTypes["default"].string,
    onClick: _propTypes["default"].func
  }),
  className: _propTypes["default"].string
};
FeedbackScreen.defaultProps = {
  title: undefined,
  primaryButton: undefined,
  secondaryButton: undefined,
  className: ''
};
var _default = exports["default"] = FeedbackScreen;